import React from 'react';

import { useService } from '@xstate/react';

import { productBuilderMachine } from '../../../context/ProductBuilder/machine';
import { getBaseProduct } from '../../../helpers/getBaseProduct';
import { Caption } from "../../Common/Caption";
import { getBaseProductType } from '../../../helpers/getBaseProductType';
import { getProductStateConfig } from '../../../helpers/getProductStateConfig';
import { isCurrentState } from '../../../helpers/isCurrentState';
import { throwError } from '../../../helpers/throwError';
import {
    ProductBuilderMachineContext,
    ProductBuilderMachineEvent,
} from '../../../types';
import { Heading } from '../../Common/Heading';
import { Selector, SelectorImageItem } from '../../Common/Selector';
import { SectionContent } from './SectionContent';

type OnClick = (
    option: string,
    send: (event: ProductBuilderMachineEvent) => void,
) => () => void;

const onClick: OnClick = (option, send) => () => {
    const pleatFinish = `${option}`;
console.log('pleatFinish', pleatFinish);
    send({
        type: 'UPDATE_CUSTOM',
        custom: {
            pleatFinish,
        },
    });
};

export const PleatFinish = () => {
    const [state, send] = useService(productBuilderMachine);
    const {
        products,
        custom: { pleatFinish },
    } = state.context;

    const liningTypes = products && products.length ? products.reduce((accumulator: string[], currentObject) => {
        return accumulator.concat(currentObject.metafields.pleat_finish || []);
    }, []) : [];
    // const liningTypes = products ? products[1].metafields.pleat_finish || [] : [];
    const productType = getBaseProductType(state.context);

    if (isCurrentState('pleatFinish', state) && liningTypes.length === 0) {
        throwError(state);
    }

    return (
        <SectionContent>
            <Heading>Pleat Finish</Heading>
            <Selector isSlider={true}>
                
                {liningTypes.map(option => {
                    const { showIcon, Icon, description } = getProductStateConfig(
                        productType,
                        'pleatFinish',
                        option,
                    );
                    return (
                        <SelectorImageItem
                            isSelected={
                                option ===
                                (typeof pleatFinish !== 'undefined' ? pleatFinish.split(':')[0] : '')
                            }
                            onClick={onClick(option, send)}
                            showIcon={showIcon}
                            Icon={Icon}
                            title={option}
                            key={option}
                            description={description}
                        />
                    );
                })}
            </Selector>
            {pleatFinish &&
                typeof pleatFinish !== 'undefined' && (
                    <Caption>
                        If you choose a single or double pleat with a Royal finish? Then the pleat band at the top
                        of your curtain is 2 cm longer than normal. This makes the pleat stand out better and the 
                        fabric falls more elegantly.
                    </Caption>
                )}
        </SectionContent>
    );
};
